import { Component, OnInit, HostListener } from '@angular/core';
import { UserSettingsService } from '../user-settings.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment-timezone';
import { SnackbarComponent } from 'src/app/snackbar/snackbar.component';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
declare var $;

@Component({
  selector: 'app-useraccount-settings',
  templateUrl: './useraccount-settings.component.html',
  styleUrls: ['./useraccount-settings.component.css'],
})
export class UseraccountSettingsComponent implements OnInit {
  // api_url
  url = environment.api_url;

  showConfirmMail = false;
  showConfirmPassword = false;
  saveButton = true;
  ngClass = false;
  confirmPhoneNum = false;
  // disable function
  disablePassword = false;
  disablePhone = false;
  disableEmail = false;

  checkOldFieldOtp = false;
  checkNewFieldOtp = false;
  checkPasswordFieldOtp = false;
  sendEmailEnable = false;
  phoneNumberKey = false;
  resendOtpPsw = false;
  againCheck = false;

  phoneNumbervalidate = false;
  confirmNumbervalidate = false;

  closebutton = false;
  phoneNumberFieldShow = false;
  userObj = {
    fName: '',
    lName: '',
    emailId: '',
    password: '',
    phone: '',
    oldPhoneNumber: '',
    confirm_phone: '',
    confirmEmailId: '',
    oldEmail: '',
    hg_accountId: '',
    isUserEmailChanged: false,
    newEmail: '',
    changeEmailPassword: '',
    oldOtp: '',
    newOtp: '',
    isPasswordChanged: false,
    isPhoneChanged: false,
    oldPassword: '',
    initialEmail: '',
    confirm_password: '',
  };
  changeEmail = false;
  passwordFieldShow = false;
  emailFieldShow = false;
  disablePasswordUser = false;
  disablePhoneUser = false;
  dataValue;
  disableEmailUser = false;
  display = 'none';
  newUserObject: any;
  changeAccountResult: any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  error = 'Error';
  deviceWidth: number;
  browserValue: string;

  constructor(
    private userSettingsService: UserSettingsService,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar
  ) {}
  ngOnInit() {
    this.deviceWidth = window.innerWidth;
    this.browserView();
    this.userObj.isPasswordChanged = false;
    this.userObj.isUserEmailChanged = false;
    this.userObj.isPhoneChanged = false;
    this.userSettingsService.getHgUserObj();
    this.userSettingsService.getUserObj.subscribe((data) => {
      this.dataValue = data.userObj.user.type;
      if (data['userObj']) {
        this.userObj = data['userObj'].user;
        this.userObj.initialEmail = data.userObj.user.emailId;
        this.userObj.oldEmail = data.userObj.user.emailId;
        this.userObj.hg_accountId = data.userObj.user.Id;
        this.userObj.password = data.userObj.user.password;
        this.userObj.oldPassword = data.userObj.user.password;
        this.userObj.phone = data.userObj.user.phone;
        this.userObj.oldPhoneNumber = data.userObj.user.phone;
        if (this.dataValue === 'gmail' || this.dataValue === 'facebook') {
          this.disableEmailUser = true;
          this.disablePasswordUser = true;
          this.disablePhoneUser = true;
          if (this.userObj.password === null || this.userObj.password === '') {
            this.passwordFieldShow = true;
          }
          if (this.userObj.phone === null || this.userObj.phone === '') {
            this.phoneNumberFieldShow = true;
          }
          if (
            this.userObj.initialEmail === null ||
            this.userObj.initialEmail === ''
          ) {
            this.emailFieldShow = true;
          }
        }
      }
    });
    document.getElementById('emailRead').setAttribute('readonly', '');
    document.getElementById('passwordRead').setAttribute('readonly', '');
    document.getElementById('txtnumber').setAttribute('readonly', '');
  }

  changemailid() {
    this.showConfirmMail = true;
    this.closebutton = true;
    this.disablePassword = true;
    this.disablePhone = true;
    this.userObj.initialEmail = '';
    this.userObj.isUserEmailChanged = true;
    this.changeEmail = true;
    document.getElementById('emailRead').removeAttribute('readonly');
  }

  // Change Password
  changePassword() {
    this.showConfirmPassword = true;
    this.closebutton = true;
    this.disablePhone = true;
    this.disableEmail = true;
    this.userObj.isPasswordChanged = true;
    this.userObj.password = '';
    document.getElementById('passwordRead').removeAttribute('readonly');
  }

  // change the Phone number
  changePhoneNum() {
    this.confirmPhoneNum = true;
    this.closebutton = true;
    this.disableEmail = true;
    this.disablePassword = true;
    this.userObj.phone = '';
    this.userObj.isPhoneChanged = true;
    document.getElementById('txtnumber').removeAttribute('readonly');
  }

  // Phone number validation
  numberValidation(e, phoneParam) {
    if (phoneParam === 'phone') {
      this.phoneNumbervalidate = true;
    } else if (phoneParam === 'confirm_phone') {
      this.confirmNumbervalidate = true;
    }
    const key = e.charCode || e.keyCode || 0;
    const text = e.target.value;
    if (
      (key >= 96 && key <= 105) ||
      key === 45 ||
      (key >= 48 && key <= 57) ||
      key === 189 ||
      key === 109 ||
      key === 46 ||
      key === 37 ||
      key === 39
    ) {
      if (this.phoneNumbervalidate === true) {
        if (text.length === 3) {
          this.userObj.phone = text + '-';
        }
        if (text.length === 7) {
          this.userObj.phone = text + '-';
        }
      } else if (this.confirmNumbervalidate === true) {
        if (text.length === 3) {
          this.userObj.confirm_phone = text + '-';
        }
        if (text.length === 7) {
          this.userObj.confirm_phone = text + '-';
        }
      }
    } else if (key === 8) {
      return true;
    } else {
      return false;
    }
    this.confirmNumbervalidate = false;
    this.phoneNumbervalidate = false;
  }

  // Close the Confirm Address Details
  closeConfirmAddress() {
    this.confirmPhoneNum = false;
    this.showConfirmPassword = false;
    this.showConfirmMail = false;
    this.closebutton = false;
    this.saveButton = true;
    this.ngClass = false;
    this.disablePhone = false;
    this.disablePassword = false;
    this.disableEmail = false;
    this.userObj.initialEmail = this.userObj.oldEmail;
    this.userObj.password = this.userObj.oldPassword;
    this.userObj.isPasswordChanged = false;
    this.userObj.isUserEmailChanged = false;
    this.userObj.confirm_phone = '';
    this.userObj.confirm_password = '';
    this.userObj.confirmEmailId = '';
    this.userObj.isPhoneChanged = false;
    this.userObj.phone = this.userObj.oldPhoneNumber;
    document.getElementById('emailRead').setAttribute('readonly', '');
    document.getElementById('passwordRead').setAttribute('readonly', '');
    document.getElementById('txtnumber').setAttribute('readonly', '');
  }

  // save changes
  changeAccount(event) {
    this.display = 'block';
    this.changeEmail = true;
    this.userObj.newEmail = this.userObj.confirmEmailId;
    this.userObj.hg_accountId = this.userObj['_id'];
    const body = new HttpParams().append(
      'userObj',
      JSON.stringify(this.userObj)
    );
    this.http
      .post(this.url + '/changeEmail/generateOtp', body)
      .subscribe((res: any) => {
        // this.spinner.hide();
        this.display = 'none';
        const result = res;
        if (result.statusCode === '002') {
          this.openSnackBar(result.statusText, this.error);
          this.userObj.initialEmail = '';
          this.userObj.confirmEmailId = '';
          this.saveButton = true;
        } else {
          this.newUserObject = result;
          $('#emailModal').modal('show');
        }
      });
  }

  saveChanges() {
    console.log(this.newUserObject);
    this.display = 'block';
    var currentTime = this.getCurrentDatePerCST(new Date());
    var resetValidTime = this.newUserObject.loggedDate.split(' ')[1].split(':');
    resetValidTime = `${resetValidTime[0]}${resetValidTime[1]}`;
    if (resetValidTime <= currentTime) {
      if (this.validateOTP()) {
        const body = new HttpParams().append(
          'userObj',
          JSON.stringify(this.setUserObjectDetails(this.newUserObject))
        );
        this.http
          .post(this.url + '/saveUserSettings', body)
          .subscribe((res: any) => {
            this.display = 'none';
            $('#emailModal').modal('hide');
            this.ngOnInit();
            this.closeConfirmAddress();
            this.openSnackBar(res.statusText, 'Success');
          });
      } else {
        this.openSnackBar('Invalid OTP', this.error);
      }
    } else {
      this.openSnackBar('Session Timed Out', this.error);
    }
  }

  setUserObjectDetails(newUserObject: any) {
    let userObj;
    if (newUserObject.data.isUserEmailChanged)
      userObj = {
        hg_accountId: newUserObject.data._id,
        emailId: newUserObject.data.confirmEmailId,
      };
    if (newUserObject.data.isPasswordChanged)
      userObj = {
        hg_accountId: newUserObject.data._id,
        password: newUserObject.data.confirm_password,
        isPasswordChanged: true,
      };
    if (newUserObject.data.isPhoneChanged)
      userObj = {
        hg_accountId: newUserObject.data._id,
        phone: newUserObject.data.confirm_phone,
      };
    return userObj;
  }

  validateOTP() {
    return this.newUserObject.newOTPCode.toString() === this.userObj.newOtp
      ? true
      : false;
  }

  getCurrentDatePerCST(itemDate) {
    let newDate = moment(itemDate)
      .utc()
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    var m = moment.utc(newDate);
    m.tz('America/Chicago');
    const endtime = moment(m, 'HH:mm:ss').add('15', 'minutes').format('HHmm');
    // return m.format('HHmm');
    return endtime;
  }

  resendOtp() {
    this.resendOtpPsw = true;
    this.changeAccount('resend');
  }

  checkOldField(this) {
    if (this.value === '') {
    } else {
      this.checkOldFieldOtp = true;
      if (
        this.checkOldFieldOtp &&
        this.checkNewFieldOtp &&
        this.checkPasswordFieldOtp
      ) {
        this.sendEmailEnable = true;
      }
    }
  }

  checkNewField(this) {
    this.sendEmailEnable = false;
    if (this.userObj.newOtp) this.sendEmailEnable = true;
  }

  checkPasswordField(this) {
    if (this.value === '') {
    } else {
      this.checkPasswordFieldOtp = true;
      if (
        this.checkOldFieldOtp &&
        this.checkNewFieldOtp &&
        this.checkPasswordFieldOtp
      ) {
        this.sendEmailEnable = true;
      }
    }
  }

  saveBtnEnable(field) {
    if (
      field === 'mail' &&
      this.userObj.initialEmail === this.userObj.confirmEmailId
    ) {
      this.saveButton = false;
    } else if (
      field === 'password' &&
      this.userObj.password === this.userObj.confirm_password
    ) {
      this.saveButton = false;
    } else if (
      field === 'mobile' &&
      this.userObj.phone === this.userObj.confirm_phone
    ) {
      this.saveButton = false;
    } else if (
      field === 'mobile' &&
      this.userObj.phone !== this.userObj.confirm_phone
    ) {
      this.saveButton = true;
    } else if (
      field === 'password' &&
      this.userObj.password !== this.userObj.confirm_password
    ) {
      this.saveButton = true;
    } else if (
      field === 'mail' &&
      this.userObj.initialEmail !== this.userObj.confirmEmailId
    ) {
      this.saveButton = true;
    }
    if (this.saveButton) {
      this.ngClass = true;
    }
    this.phoneNumberKey = true;
  }

  onPaste(event) {
    this.userObj.confirm_phone = event.target.value;
    event.preventDefault();
    if (this.userObj.phone === this.userObj.confirm_phone) {
      this.ngClass = true;
      this.saveButton = false;
      this.phoneNumberKey = true;
    }
  }

  onPhPaste(event) {
    this.userObj.phone = event.target.value;
    event.preventDefault();
  }

  enableClick() {
    $('.enableImg').hide();
    $('.disableImg').show();
    const documentValue = document.getElementById('enableImgeId');
    const documentDisable = document.getElementById('disableImgeId');
    documentValue.classList.add('d-none');
    documentValue.classList.remove('d-block');
    documentDisable.classList.add('d-block');
    documentDisable.classList.remove('d-none');
  }
  enableClicksec() {
    $('.enableImg').hide();
    $('.disableImg').show();
    const documentValuesec = document.getElementById('enableImgeIdsec');
    const documentDisablesec = document.getElementById('disableImgeIdsec');
    documentValuesec.classList.add('d-none');
    documentValuesec.classList.remove('d-block');
    documentDisablesec.classList.add('d-block');
    documentDisablesec.classList.remove('d-none');
  }

  disEnableClick() {
    $('.disableImg').hide();
    $('.enableImg').show();
    const documentValue = document.getElementById('enableImgeId');
    const documentDisable = document.getElementById('disableImgeId');
    documentValue.classList.add('d-block');
    documentValue.classList.remove('d-none');
    documentDisable.classList.add('d-none');
    documentDisable.classList.remove('d-block');
  }
  disEnableClicksec() {
    $('.disableImg').hide();
    $('.enableImg').show();
    const documentValuesec = document.getElementById('enableImgeIdsec');
    const documentDisablesec = document.getElementById('disableImgeIdsec');
    documentValuesec.classList.add('d-block');
    documentValuesec.classList.remove('d-none');
    documentDisablesec.classList.add('d-none');
    documentDisablesec.classList.remove('d-block');
  }

  getOTPMessage() {
    return this.userObj.isUserEmailChanged
      ? 'OTP Sent to New EMail-Id'
      : this.userObj.isPasswordChanged
      ? 'OTP Sent to EMail-Id'
      : '';
  }

  openSnackBar(statusText, title) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 30000,
      data: {
        name: statusText,
        title: title,
      },
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: title === 'Error' ? 'bg-danger' : 'bg-success',
    });
  }

  browserView() {
    this.browserValue = this.deviceWidth < 768 ? 'Mob' : 'Web';
  }

  closeAll() {
    this.showConfirmPassword = false;
    this.showConfirmMail = false;
    this.confirmPhoneNum = false;
    this.disablePassword = false;
    this.disableEmail = false;
    this.disablePhone = false;
  }
}
